export enum actions {
  SET_CONTENT = 'SET_CONTENT'
}
